import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { OrganisationInput } from "@/app/Organisations/Components/OrganisationInput";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { addUserToOrganisationMutation } from "@/app/Users/GraphQL/userMutations";
import { toast } from "sonner";

export function AddUserToOrganisationDialog({ userId }: { userId: string }) {
  const { close } = useDialogState();
  const { mutateAsync } = useGqlMutation(addUserToOrganisationMutation);

  return (
    <BaseDialog title="Add to organisation" size="sm">
      <GenericForm
        initialValues={{
          organisation_id: null!,
        }}
        onSubmit={async (values) => {
          await mutateAsync({
            organisation_id: values.organisation_id,
            user_id: userId,
          });

          toast.success("User added to organisation");
          close();
        }}
      >
        <OrganisationInput
          name="organisation_id"
          label="Organisation"
          className="col-span-full"
        />
        <DialogSubmitButton text="Add" />
      </GenericForm>
    </BaseDialog>
  );
}
